import React from 'react';
import { Box } from '@mui/material';
import GraficoBarrasPadrao from './GraficoBarraPadrao'; // Importa o componente base

/**
 * StatusBarChart - Componente para exibir um gráfico de barras com estatísticas de atendimentos por status.
 * 
 * Versão estilizada com design responsivo e visual aprimorado seguindo os padrões do HomeLogado
 * 
 * @param {Array<number>} data - Valores numéricos para cada categoria/status
 * @param {Array<string>} labels - Nomes das categorias/status
 * @param {number} total - Total de atendimentos
 * @param {number} emAberto - Quantidade de atendimentos em aberto
 * @param {number} concluidos - Quantidade de atendimentos concluídos
 */
const StatusBarChart = ({ data = [], labels = [], total = 0, emAberto = 0, concluidos = 0 }) => {
  return (
    <Box>
      {/* Container do Gráfico */}
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: 2,
          borderRadius: 2,
          backgroundColor: 'background.paper',
          p: 1.5
        }}>
        <GraficoBarrasPadrao
          titulo="Status dos atendimentos" // Removemos o título pois já temos no header
          labels={labels}
          data={data}
          cor="#667eea" // Cor que combina com o gradient
          legendaY="Atendimentos"
        />
      </Box>
    </Box>
  );
};

export default StatusBarChart;